import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
    <Svg
        width={props.size || 24}
        height={props.size || 24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M16.5 7.55L6.725 17.325C6.575 17.475 6.4 17.55 6.2 17.55C6 17.55 5.825 17.475 5.675 17.325C5.525 17.175 5.45 16.9958 5.45 16.7875C5.45 16.5792 5.525 16.4 5.675 16.25L15.45 6.5H6.75C6.53333 6.5 6.35416 6.42917 6.2125 6.2875C6.07083 6.14583 6 5.96667 6 5.75C6 5.53333 6.07083 5.35417 6.2125 5.2125C6.35416 5.07083 6.53333 5 6.75 5H17.25C17.4667 5 17.6458 5.07083 17.7875 5.2125C17.9292 5.35417 18 5.53333 18 5.75V16.25C18 16.4667 17.9292 16.6458 17.7875 16.7875C17.6458 16.9292 17.4667 17 17.25 17C17.0333 17 16.8542 16.9292 16.7125 16.7875C16.5708 16.6458 16.5 16.4667 16.5 16.25V7.55Z"
            fill={props.color || "#1D2939"}
        />
    </Svg>
);
export default SVGComponent;
